module.exports = __webpack_public_path__ + "img/integrity.62388522.jpg";